module.exports = __webpack_public_path__ + "fonts/Blogger Sans Bold.76b00d5b.ttf";